import PageHeader from '../../../Layout/PageHeader'
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import FormButton from "../../../Components/Buttons/FormButton";
import { HistoryLaoutDataCycleCountDetail, cyclecountdetailslist as initialCycleCountDetailsList } from "../../../Data/testData";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import Table, { Column } from "../../../Components/Tables/Table";
import { useEffect } from "react";
import CommonModal from "../../../Components/Modals/CommonModal";
import AssignToUserLayout from "../../../Layout/AssignToUserLayout";
import RecountedLayout from "../../../Layout/RecountedLayout";
import ExpandableContentLayout from "../../../Layout/ExpandableContentLayout";
import historyIcon from "../../../assets/images/history-icon.svg";
import warningIcon from "../../../assets/images/warning.svg";
import HistoryLayout from '../../../Layout/HistoryLaout';
import DynamicDetailGrid from '../../../Components/Grid/DynamicDetailGrid';


export default function CycleCountDetails() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Cycle Count (${id})`;

  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const backNavigate = () => {
    return navigate(`/inventory/counts/cycle-count`);
  }

  const handleClose = () => {
    backNavigate();
  }

  const handleRecountChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const updatedData = [...cyclecountdetailslist];
    updatedData[index].recount = e.target.checked ? 1 : 0;
    setCycleCountDetailsList(updatedData);
  };

  const [cyclecountdetailslist, setCycleCountDetailsList] = useState(initialCycleCountDetailsList);

  useEffect(() => {
    setCycleCountDetailsList(initialCycleCountDetailsList);
  }, []);

  const handelInactiveAction = () => { setShow(true); };

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(false);

  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };

  const [showRecountModal, setShowRecountModal] = useState(false);

  const handleWarningClick = () => {
    setShowRecountModal(true);
  };

  const closeRecountModal = () => {
    setShowRecountModal(false);
  };

  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" alt="no image" />
            History
          </h6>
        </div>
      </div>
    </>
  );

  const columns: Column[] = [
    {
      name: "Line No.",
      selector: (row: { line: string }) => row.line,
    },
    {
      name: "Item Code",
      selector: (row: { item_code: { imgSrc: string; text: string } }) => (
        <div>
          {row.item_code.imgSrc && (
            <img
              src={require(`../../../assets/images/${row.item_code.imgSrc}`)}
              alt={row.item_code.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.item_code.text}
        </div>
      ),
    },
    {
      name: "System Qty",
      selector: (row: { system_qty: string }) => row.system_qty,
    },
    {
      name: "Counted Qty",
      selector: (row: { counted_qty: string }) => row.counted_qty,
    },
    {
      name: "Variance",
      selector: (row: { varience: string }) => row.varience,
    },
    {
      name: "Location",
      selector: (row: { location: string }) => row.location,
    },
    {
      name: "Cost",
      selector: (row: { cost: number }) => row.cost,
    },
    {
      name: "Recount Qty",
      selector: (row: { recount_qty: number }) => row.recount_qty,
    },
    {
      name: "Recount",
      selector: (row: { recount: number, is_recounted: number }, index?: number) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={!!row.recount}
            onChange={(e) => handleRecountChange(e, index ?? 0)}
          />
          {row.is_recounted === 1 && (
            <img
              src={warningIcon}
              alt="Recounted"
              style={{ width: "18px", marginRight: "8px", marginLeft: "20px" }}
              onClick={handleWarningClick}
              className="cursor-pointer"
            />
          )}
        </div>
      ),
    }
  ];
  const CycleCountData = {
    CycleCountExpanded:
      [
        { label: 'Created Date', value: "03/15/2023" },
        { label: 'Created By', value: "John Hammer" },
        { label: 'Counted By', value: "Benjamin" },
        { label: 'Count Type', value: "By Item" },
        {
          label: 'Status', value: (
            <>
              <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                New
              </div>
            </>
          )
        }
      ],

      CycleCountDefault: [
        { label: 'Created Date', value: "03/15/2023" },
        { label: 'Created By', value: "John Hammer" },
        { label: 'Counted By', value: "Benjamin" }
    ]
  }
  return (
    <>
      <PageHeader
        listUrl={`/inventory/counts/cycle-count`}
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12  px-5 ">
              <DynamicDetailGrid customClassName="my-1 col-10" isExpandable={false} columns={3} data={CycleCountData.CycleCountExpanded} />
              
              <div className="col-2">
                <div className="align-self-center d-flex flex-row-reverse my-4">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="checkin-details row align-items-center d-flex bg-white col-12 px-5 ">
              <DynamicDetailGrid customClassName="my-1 col-10" isExpandable={false} columns={3} data={CycleCountData.CycleCountDefault} />

              <div className="col-2">
                <div className="align-self-center d-flex flex-row-reverse">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 rounded bg-white py-1 px-2">
        <Table
          columns={columns}
          data={cyclecountdetailslist}
          CheckboxStatus={false}
          customClassName="transferDetailsTable cycleCountDetailsTable"
          isStripped={true}
          isExpandable={true}
          expandableContentLayout={(row: any) => (
            <ExpandableContentLayout row={row} />
          )}
        />
      </div>
      <div className="bg-white rounded py-3 mt-auto">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handelInactiveAction()}>
            Approve
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}>
            Cancel
          </FormButton>
        </div>
      </div>
      <CommonModal
        handleClose={() => setShow(false)}
        show={show}
        heading="Assign To"
        content={<AssignToUserLayout handleClose={handleShow} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
      />
      <CommonModal
        handleClose={closeRecountModal}
        show={showRecountModal}
        content={<RecountedLayout handleClose={closeRecountModal} />}
        modalSize="modal-md"
      />

      <HistoryLayout isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutDataCycleCountDetail} />
    </>
  );
}
